import Header from "./sub-components/Header";
import '../../../src/styles/upgrade.css'
import { Button } from "@mui/material";
import { db } from './firebase/firebase';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, setDoc, getDocs, collection, getDoc, query, addDoc, where, updateDoc } from "firebase/firestore";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { de_encrypt } from "../../encryption";
import BaseNav from "./sub-components/BaseNav";
const Withdrawal = () => {
    const navigate = useNavigate();
    const user_key = de_encrypt(localStorage.getItem('user-key'));
    const [user, setUser] = useState(null);
    const [error, setError] = useState('');
    const [clicked, setClicked] = useState(false);
    const [amount, setAmount] = useState('');
    const userRef = collection(db, "user");
    const [config,setConfig]=useState({lock_withdrawal:false});

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#9900EF",
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14
        },
    }));
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));
    const referral_quota = (package_type) => {
        var amount = '';
        switch (package_type) {
            case "starter":
                amount = 5000;
                break;

            default:
                amount = 10000;
        }
        return amount
    }
    const withdrawable_amount = (package_type) => {
        var amount = '';
        switch (package_type) {
            case "starter":
                amount = 6000;
                break;

            case "premium":
                amount = 10000;
                break;

            case "premium pro":
                amount = 10000
                break;

            case "elite":
                amount = 20000;
                break;

            case "expert":
                amount = 30000;
                break;

            case "worker":
                amount = 40000;
                break;
        }
        return amount
    }
    useEffect(
        () => {
            if (user == null) {
                (async () => {
                    const docRef = doc(db, "user", user_key);
                    const docSnap = await getDoc(docRef);
                    //const configRef = doc(db, "admin", "config");
                    // const configSnap = await getDoc(configRef);
                    setUser(docSnap.data())
                  //  setConfig(configSnap.data())
                })();
            }
        }, [user])

    const [wd, setWd] = useState(null);
    const all_wd = []
    useEffect(() => {
        if (wd == null) {
            (async () => {
                const q = query(collection(db, "withdrawal"), where("email", "==", user_key));
                const querySnapshot = await getDocs(q);
                querySnapshot.forEach((doc) => {
                    all_wd.push(doc.data())
                });
                setWd(all_wd.sort((a, b) => { return b.time - a.time }))
            })()
        }
    }, [wd])
    const withdraw = async (withdrawal_type) => {
        setClicked(true);
        const quota_validation = withdrawal_type == 'mine' ? user.mine_balance >= withdrawable_amount(user.package_type) : user.referal_balance >= referral_quota(user.package_type);
        const balance_validation = withdrawal_type == 'mine' ? user.mine_balance >= amount : user.referal_balance >= amount;
        const quota_amount = withdrawal_type == 'mine' ? withdrawable_amount(user.package_type) : referral_quota(user.package_type);

        const balance = withdrawal_type == 'mine' ? user.mine_balance : user.referal_balance
        if (user.withdrawal) {
            setClicked(false);
            setError('Request failed, you have a pending withdrawal');
            return
        }
        if (user.acct_num == undefined) { navigate('/dashboard/account') }

        if (amount != '') {
            if (withdrawal_type != 'mine') {
                if (quota_validation) {
                    if (balance_validation) {
                        if (parseInt(amount) >= 1000) {
                            const today = new Date();
                            const notification_data = {
                                type: 'withdrawal',
                                subject: `Withdrawal request`,
                                body: `Your withdrawal request of ${amount} naira has been sent, once validated it will be approved, await an aproval notification or otherwise.`,
                                time: Date.now(),
                                to: user_key
                            }

                            const w_data = {
                                email: user_key,
                                time: Date.now(),
                                date: `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()} ${today.getHours()}:${today.getMinutes()}`,
                                desc: `${withdrawal_type} withdrawal (${amount})`,
                                status: "pending",
                                type: withdrawal_type,
                                acct_name: user.acct_name,
                                acct_num: user.acct_num,
                                bank_name: user.bank_name,
                                amount: parseInt(amount)
                            }
                            const wRef = await addDoc(collection(db, "withdrawal"), w_data);
                            const nRef = await addDoc(collection(db, "notifications"), notification_data);
                            const userRef = doc(db, "user", user_key);
                            const u_data = {
                                withdrawal: true
                            }
                            await updateDoc(userRef, u_data);
                            setClicked(false);
                            setError('');
                            setUser(null);
                            setAmount(null);
                            setWd(null);
                        } else {
                            setError('Only an amount greater than ₦1000 is withdrawable.');
                            setClicked(false)
                        }
                    } else {
                        setError('Insufficient balance');
                        setClicked(false)
                    }
                } else {
                    setError(`Your mine balance has to be ₦${quota_amount} to be able to withdraw, you need ₦${quota_amount - balance} more`)
                    setClicked(false);

                }
            }

            if (withdrawal_type == 'mine') {
                if (parseInt(amount) <= (0.1 * user.mine_balance)) {
                    if (parseInt(amount) >= 1000) {
                        const today = new Date();
                        const notification_data = {
                            type: 'withdrawal',
                            subject: `Withdrawal request`,
                            body: `Your withdrawal request of ${amount} naira has been sent, once validated it will be approved, await an aproval notification or otherwise.`,
                            time: Date.now(),
                            to: user_key
                        }

                        const w_data = {
                            email: user_key,
                            time: Date.now(),
                            date: `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()} ${today.getHours()}:${today.getMinutes()}`,
                            desc: `${withdrawal_type} withdrawal (${amount})`,
                            status: "pending",
                            type: withdrawal_type,
                            acct_name: user.acct_name,
                            acct_num: user.acct_num,
                            bank_name: user.bank_name,
                            amount: parseInt(amount)
                        }
                        const wRef = await addDoc(collection(db, "withdrawal"), w_data);
                        const nRef = await addDoc(collection(db, "notifications"), notification_data);
                        const userRef = doc(db, "user", user_key);
                        const u_data = {
                            withdrawal: true
                        }
                        await updateDoc(userRef, u_data);
                        setClicked(false);
                        setError('');
                        setUser(null);
                        setAmount(null);
                        setWd(null);
                    }
                } else {
                    setError(`You can only withdraw 10% of your mine earning which is ${Math.floor(0.1 * user.mine_balance)} naira `);
                    setClicked(false)
                }
            }
        } else {
            setError('Please fill all fields to proceed');
            setClicked(false)
        }
    }
    if(config != undefined){
     if(!config.lock_withdrawal){
      return (
        <div className="dashboard upgrade-container utility">
            <Header />
            <BaseNav active={"Withdraw"} />

            {user &&
                <div className="gc-box">
                    <span>Hello there, input an amount to withdraw to proceed </span>
                    <div className="text-field">
                        <input type="number" placeholder='Enter Amount' value={amount} onChange={(e) => { setAmount(e.target.value) }} />
                    </div>

                    {!clicked && <div className="btn">
                        <Button variant="contained" style={{ backgroundColor: "#9900EF" }} onClick={() => { withdraw('mine') }}>Mine Withdrawall</Button>
                    </div>}

                    {!clicked && <div className="btn">
                        <Button variant="contained" style={{ backgroundColor: "#9900EF" }} onClick={() => { withdraw('referral') }}>Referral Withdrawal</Button>
                    </div>}

                    {clicked && <div className="btn">
                        <Button variant="contained" style={{ backgroundColor: "#9900EF" }} > Processing</Button>
                    </div>}
                    <p style={{ color: "red", transform: "translateY(2em)", fontSize: "13px" }}>{error}</p>
                </div>
            }
            {wd && <div className="container">
                <h3 style={{ textAlign: "center", marginBottom: "1em" }}>Withdrawal logs</h3>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>S/N</StyledTableCell>
                                <StyledTableCell align="center">Email</StyledTableCell>
                                <StyledTableCell align="center">Type&nbsp;</StyledTableCell>
                                <StyledTableCell align="center">Date&nbsp;</StyledTableCell>
                                <StyledTableCell align="center">Status&nbsp;</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {wd.map((row, index) => (
                                <StyledTableRow key={row.name}>
                                    <StyledTableCell component="th" scope="row">
                                        {index++}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">{row.email}</StyledTableCell>
                                    <StyledTableCell align="center">{row.type}</StyledTableCell>
                                    <StyledTableCell align="center">{row.date}</StyledTableCell>
                                    <StyledTableCell align="center">{row.status}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>}



        </div>
    );
}else{
  return (
        <div className="dashboard upgrade-container utility" style={{backgroundcColor:"white"}}>
            <Header />
            <BaseNav active={"Withdraw"} />
            <div className="container">
               <img src="https://res.cloudinary.com/dles2mycv/image/upload/v1643852911/undraw_warning_cyit_lu7k2a.png" style={{width:"100%"}}/>
               <h3 style={{textAlign:"center"}}>The withdrawal portal is currently closed. Check back later.</h3>
            </div>
       </div>)
}
}
}

export default Withdrawal;
